import React from 'react';
import { ReactFormGenerator } from 'react-form-builder2';

import { useFormBuilderContext } from 'lib/context/FormBuilder/FormBuilderContext';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';

const Preview = ({ setPreviewMode }) => {
  const { formik } = useFormBuilderContext();
  return (
    <>
      <div className="!m-[10px] !mb-0 flex h-[62px] items-center justify-between rounded-[16px] bg-primary-500 p-4">
        <div className="flex gap-2">
          <Icon icon="eye-mono" color="white" />
          <p className="text-sm font-500 text-white">Preview mode</p>
        </div>
        <Button
          text="Back to edit"
          variant="secondary"
          style="outlined"
          onClick={() => setPreviewMode(false)}
        />
      </div>
      <div className="relative p-4">
        <div className="cursor-not-allowed content-[''] before:absolute before:top-0 before:z-10 before:h-full before:w-full before:opacity-30">
          <ReactFormGenerator
            data={formik?.values?.form?.json?.fields || []}
            submitButton={<div />}
            // hide_actions
            read_only
          />
        </div>
      </div>
    </>
  );
};

export default Preview;
